import { trackEvent } from "@/src/utils/tracking";

const SESSION_PREFIX = "plan_activity_analytics:";

function trackPlanViewOnce(
  sessionKey: string,
  event: string,
  params?: Record<string, string | number | boolean>,
): void {
  if (typeof window === "undefined") {
    return;
  }
  const storageKey = `${SESSION_PREFIX}${sessionKey}`;
  if (sessionStorage.getItem(storageKey)) {
    return;
  }
  sessionStorage.setItem(storageKey, "1");
  trackEvent(event, params);
}

export function trackPlanActivityView(isPaid: boolean): void {
  trackPlanViewOnce(`activity_view:${isPaid}`, "plan_activity_view", {
    is_paid: isPaid,
  });
}

export function trackPlanActivityEmptyView(): void {
  trackPlanViewOnce("activity_empty", "plan_activity_empty_view");
}

export function trackPlanUnactivatedGoalTap(hasPlan: boolean): void {
  trackEvent("plan_unactivated_goal_tap", { has_plan: hasPlan });
}

export function trackPlanSetGoalTap(): void {
  trackEvent("plan_set_goal_tap");
}

export function trackPlanSetGoalDone(): void {
  trackPlanViewOnce("set_goal_done", "plan_set_goal_done");
}

export function trackPlanGoalDetailView(): void {
  trackPlanViewOnce("goal_detail_view", "plan_goal_detail_view", {
    activated: false,
  });
}

export function trackPlanCalendarLockTap(): void {
  trackEvent("plan_calendar_lock_tap");
}

export function trackPlanDashboardUnlockTap(): void {
  trackEvent("plan_dashboard_unlock_tap");
}

export function trackPlanSubtabSwitch(
  tab: "checkup" | "my_goals" | "dashboard",
): void {
  trackEvent("plan_subtab_switch", { tab });
}

export function trackPlanActivatedGoalChatTap(): void {
  trackEvent("plan_activated_goal_chat_tap");
}

// ─── Slice 5: Onboarding activation funnel events ───

/** home_state_view — Plan tab first paint */
export function trackPlanHomeStateView(params: {
  state: "no_goal_no_tracker" | "pending_goal" | "has_tracker";
  flagged_state: "full" | "empty";
  calendar_state: "full" | "empty";
}): void {
  trackEvent("home_state_view", {
    tab: "plan",
    ...params,
  });
}

/** checkup_start — Start a checkup from EdFlagCard */
export function trackCheckupStart(
  entry: "plan_flagged_empty" | "plan_flagged_allclear",
): void {
  trackEvent("checkup_start", { entry });
}

/** activate_goal_tap — Activate goal from PlanActivityBannerSection */
export function trackActivateGoalTap(): void {
  trackEvent("activate_goal_tap", { entry: "plan_flagged" });
}

/** calendar_paywall_view — Calendar lock card exposed */
export function trackCalendarPaywallView(): void {
  trackEvent("calendar_paywall_view");
}

/** get_full_access_tap — Get full access button on lock card */
export function trackGetFullAccessTap(): void {
  trackEvent("get_full_access_tap");
}

/** calendar_section_view — Calendar segment rendered */
export function trackCalendarSectionView(params: {
  today_state: "full" | "empty";
  upcoming_state: "full" | "empty";
}): void {
  trackEvent("calendar_section_view", params);
}
